module.exports = __webpack_public_path__ + "media/images/aloe/icons/categories/office-01619281d1e35918b99ddedee4fb67eb.svg";